export const unauthorizedErrors = [
  "Access Denied: Invalid or expired token. Please login again",
  "Access Denied: Please log in.",
  "Access Denied: Invalid Token.",
  "Access Denied: Invalid or expired token.",
  "Access Denied: Invalid or Expired Token.",
  "Access Denied: No token provided.",
];

export function isUnauthorizedError(error) {
  return unauthorizedErrors.includes(error?.message);
}
